import {
  PlatformLogContentLoadedTypes,
  PlatformLogPingTypes,
  PlatformLogTypeTypes,
} from "@hooks/dtos/IPlatformLogDTO";

/* eslint-disable no-param-reassign */
export const getPlatformLogContentLoadedInfo = (
  contentLoaded?: PlatformLogContentLoadedTypes
) => {
  if (!contentLoaded) return null;
  const badges: Record<PlatformLogContentLoadedTypes, any> = {
    t: { class: "success", text: "Carregado" },
    f: { class: "danger", text: "Falhou" },
  };
  return badges[contentLoaded];
};

export const getPlatformLogPingInfo = (ping?: PlatformLogPingTypes) => {
  if (!ping) return null;
  const badges: Record<PlatformLogPingTypes, any> = {
    t: { class: "success", text: "Funcionou" },
    f: { class: "danger", text: "Falhou" },
  };
  return badges[ping];
};

export const getPlatformLogTypeInfo = (ping?: PlatformLogTypeTypes) => {
  if (!ping) return null;
  const badges: Record<PlatformLogTypeTypes, any> = {
    a: { class: "success", text: "Automático" },
    m: { class: "info", text: "Manual" },
  };
  return badges[ping];
};
